import React, { useEffect, useState, useRef } from "react";
import swal from "sweetalert";
import {
  Col,
  Card,
  Table,
  Dropdown,
  Modal,
  Alert,
  Spinner,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import Baseurl from "../../../Baseurl";
import axios from "axios";
import { useHistory } from "react-router-dom";
function VerifiedRestaurants() {
  var history = useHistory();
  const sort = 5;
  const activePag = useRef(0);
  const [data, setData] = useState([]);
  const [restaurants, setRestaurant] = useState([]);
  const [restaurantId, setRestaurantId] = useState('');
  const [spinner, setSpinner] = useState(true);
  const [show, setShow] = useState(false);
  const [commStatus,setCommStatus] = useState(false);
  const [comm,setComm] = useState(0);

  function getData() {
    axios
      .get(
        `${Baseurl.baseurl4}/go-food-super-admin/get-all-verified-restaurant-details`
      )
      .then((res) => {
        console.log('result',res)
        setSpinner(false);
        if (res.data.status) {
          console.log("rest details",res.data.restaurantDetails)
          setRestaurant(res.data.restaurantDetails);
          setData(document.querySelectorAll("#job_data tbody tr"))
        }
      });
  }
  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };
  activePag.current === 0 && chageData(0, sort);
  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
  };

  useEffect(() => {
    getData();
  }, []);

  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );
function blockRestaurant(){
  const params = {
    rID:restaurantId
  };
  axios
    .put(`${Baseurl.baseurl4}/go-food-super-admin/block-restaurant-details`, params)
    .then((res) => {
      if (res.data.status) {
        swal("Blocked", res.data.message, "success", {
          button: "Done",
          timer: 1000,
        });
        getData()
      } else {
        swal("Oops", res.data.message, "error", {
          button: "Done",
          timer: 1000,
        });
      }

      setShow(false)
    })
    .catch((err) => {
    
    });
}
function updateCommission(){
  const params = {
    commission:parseInt(comm)
  };
  axios
    .put(`${Baseurl.baseurl4}/go-food/update-restaurant-commission/${restaurantId}`, params)
    .then((res) => {
      if (res.data.status) {
        swal("Updated", res.data.message, "success", {
          button: "Done",
          timer: 1000,
        });
        getData()
      } else {
        swal("Oops", res.data.message, "error", {
          button: "Done",
          timer: 1000,
        });
      }

      setShow(false)
    })
    .catch((err) => {
    
    });
}
  return (
    <Col lg={12}>
      <Modal
        size="lg"
        show={show}
        onHide={() => {
          setShow(false);
        }}
      >
        <Modal.Body>
          {commStatus?(
            <div className="row">
              <div className="col-sm-2 mt-2">
                Commission
              </div>
                <div className="col-sm-4">
                <input
                  value={comm}
                  type="number"
                  className="form-control"
                  placeholder="enter commission"
                  onChange={(e) => setComm(e.target.value)}
                  required
                />
              </div>
            </div>
          ):(
          <h4>Are You sure !! you want to block the Restaurants ?</h4>

          )}
        </Modal.Body>
        <Modal.Footer>
        {commStatus?(
          <button
          onClick={()=>{updateCommission()}}
          className="btn btn-primary">Update</button>):(
            <button
            onClick={()=>{blockRestaurant()}}
            className="btn btn-primary">Block</button>
        )}
        </Modal.Footer>
      </Modal>
      <Card
        style={{
          color: "white",
          background:
            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}
      >
        <Card.Header>
         
       
        </Card.Header>
        <Card.Body>
          <div id="job_data" className="dataTables_wrapper ">
            {spinner ? (
              <div className="text-center">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <Table className="text-white text-sm" responsive>
                <thead>
                  <tr>
                    <th>
                      <strong>NAME</strong>
                    </th>
                    <th>
                      <strong>Address</strong>
                    </th>
                    <th>
                      <strong>Style</strong>
                    </th>
                    <th>
                      <strong>Type</strong>
                    </th>
                    <th>
                      <strong>Fssalic Code</strong>
                    </th>
                    <th>
                      <strong>Status</strong>
                    </th>
                    <th>
                      <strong>Actions</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {restaurants &&
                    restaurants.map((rest, key) => (
                      <tr key={rest.id}>
                        <td>{rest.RName}</td>
                        <td>{rest.RFullAddress}</td>
                        <td>{rest.ROutletType.split(',').map((val)=>{
                          return(
                            <div>{val}</div>
                          )
                        })}</td>
                        {rest.RPureVeg ? <td>Veg</td> : <td>Non-Veg</td>}
                        <td>{rest.RFssaiLicCode}</td>
                        <td>{rest.Online?"Active":"Inactive"}</td>
                        <td>
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="warning"
                              className="light sharp i-false"
                            >
                              {svg1}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                onClick={() => {
                                history.push(`View-Restaurant/${rest._id}`)
                                }}
                              >
                                View
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => {
                                    setShow(true)
                                    setCommStatus(true)
                                    setRestaurantId(rest._id)
                                }}
                              >
                                Update Comission
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => {
                                   history.push(`View-Food-Order/${rest._id}`)
                                }}
                              >
                               View Orders
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => {
                                   history.push(`Restaurant-Items`,{items:rest.RCategoryList})
                                }}
                              >
                               View Items
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => {
                                   history.push(`View-Restaurant-Penalty/${rest._id}/rest`)
                                }}
                              >
                              View Penalty
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => {
                                 setShow(true)
                                 setRestaurantId(rest._id)
                                 setCommStatus(false)
                                }}
                              >
                                Block
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            )}

            {!restaurants && (
              <Alert
                variant="success"
                className="alert-dismissible fade show text-center"
              >
                Zero restaurants
              </Alert>
            )}
            <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
              <div className="dataTables_info text-white">
                Showing {activePag.current * sort + 1} to{" "}
                {data.length > (activePag.current + 1) * sort
                  ? (activePag.current + 1) * sort
                  : data.length}{" "}
                of {data.length} entries
              </div>
              <div
                className="dataTables_paginate paging_simple_numbers"
                id="example5_paginate"
              >
                <Link
                  className="paginate_button previous disabled"
                  onClick={() =>
                    activePag.current > 0 && onClick(activePag.current - 1)
                  }
                >
                  Previous
                </Link>
                <span>
                  {paggination.map((number, i) => (
                    <Link
                      key={i}
                      className={`paginate_button  ${
                        activePag.current === i ? "current" : ""
                      } `}
                      onClick={() => onClick(i)}
                    >
                      {number}
                    </Link>
                  ))}
                </span>
                <Link
                  className="paginate_button next"
                  onClick={() => {
                    activePag.current + 1 < paggination.length &&
                      onClick(activePag.current + 1);
                  }}
                >
                  Next
                </Link>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
    </Col>
  );
}

export default VerifiedRestaurants;
